(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-catalog"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('home-catalog')) {
    customElements.define('home-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-catalog-grid]');
        this.status = this.querySelector('[data-catalog-status]');
        this.next = this.querySelector('[data-catalog-next]');
        this.template = this.querySelector('template');
        this.phase = 'nuevo';
        this.cursor = null;
        this.ids = new Set();
        this.started = false;
        this.finished = false;
        this.loading = false;
        this.failed = false;
        this.onClick = event => {
          if (!event.target.closest('[data-catalog-next]') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadNext();
        };
        this.addEventListener('click', this.onClick);
        this.grid.style.visibility = 'hidden';
        this.status.textContent = this.dataset.loading;
        this.loadNext();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.removeEventListener('click', this.onClick);
        this.initialized = false;
      }
      card(product) {
        const card = this.template.content.firstElementChild.cloneNode(true);
        card.dataset.productId = product.id.split('/').pop();
        card.dataset.updatedAt = product.updatedAt;
        card.dataset.available = String(product.availableForSale);
        const url = this.dataset.root + 'products/' + encodeURIComponent(product.handle);
        card.querySelectorAll('a').forEach(link => { link.href = url; link.setAttribute('aria-label', product.title); });
        card.querySelector('.product-card__title a').textContent = product.title;
        card.querySelector('.product-card__vendor').textContent = /^coquine?\b/i.test(product.vendor.trim()) ? 'COQUIN' : product.vendor;
        const images = product.images.nodes;
        card.querySelectorAll('img').forEach((image, index) => {
          if (!images[index]) { image.remove(); return; }
          const source = new URL(images[index].url);
          source.searchParams.set('width', '400');
          image.src = source.href;
          image.alt = images[index].altText || product.title;
        });
        if (images.length) card.querySelector('.product-card__image--placeholder')?.remove();
        const price = product.priceRange.minVariantPrice;
        const compare = product.compareAtPriceRange.minVariantPrice;
        const money = value => new Intl.NumberFormat((document.documentElement.lang || 'es') + '-' + this.dataset.country, {
          style: 'currency', currency: value.currencyCode, currencyDisplay: 'narrowSymbol'
        }).format(Number(value.amount));
        card.querySelector('.price').textContent = money(price);
        const sale = Number(compare.amount) > Number(price.amount);
        if (sale) {
          card.querySelector('.price').classList.add('price--sale');
          card.querySelector('.price--compare').textContent = money(compare);
        } else {
          card.querySelector('.price--compare').remove();
        }
        if (product.availableForSale) card.querySelector('.badge--sold-out').remove();
        const saleBadge = card.querySelector('.badge--sale');
        if (sale && product.availableForSale) saleBadge.textContent = '-' + Math.floor((Number(compare.amount) - Number(price.amount)) * 100 / Number(compare.amount)) + '%';
        else saleBadge.remove();
        const productAge = Date.now() - Date.parse(product.createdAt);
        const showNewBadge = product.availableForSale && (product.tags.includes('REABASTECIDO') || (productAge >= 0 && productAge < 30 * 24 * 60 * 60 * 1000));
        if (!showNewBadge) card.querySelector('.badge--new').remove();
        const button = card.querySelector('.product-card__quick-add');
        if (product.availableForSale && product.selectedOrFirstAvailableVariant) {
          button.dataset.productId = product.selectedOrFirstAvailableVariant.id.split('/').pop();
          button.setAttribute('aria-label', button.title + ': ' + product.title);
        } else button.remove();
        return card;
      }
      watch() {
        this.observer?.disconnect();
        if (this.finished || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.failed) this.loadNext();
        }, { rootMargin: '350px 0px' });
        this.observer.observe(this.next);
      }
      async loadNext() {
        if (this.loading || this.finished || !this.isConnected) return;
        this.loading = true;
        this.failed = false;
        this.grid.setAttribute('aria-busy', 'true');
        this.next.setAttribute('aria-disabled', 'true');
        this.status.textContent = this.dataset.loading;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch('/api/2026-07/graphql.json', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
            signal: controller.signal,
            body: JSON.stringify({ query: "query HomeCatalog($after:String,$filter:String!,$country:CountryCode!,$language:LanguageCode!) @inContext(country:$country,language:$language) { products(first:24,after:$after,sortKey:CREATED_AT,reverse:true,query:$filter) { nodes { id handle title vendor tags availableForSale createdAt updatedAt images(first:2) { nodes { url altText } } priceRange { minVariantPrice { amount currencyCode } } compareAtPriceRange { minVariantPrice { amount currencyCode } } selectedOrFirstAvailableVariant { id } } pageInfo { hasNextPage endCursor } } }",
              variables: { after: this.cursor, filter: this.phase === 'nuevo' ? 'available_for_sale:true tag:REABASTECIDO' : this.phase === 'available' ? 'available_for_sale:true' : 'NOT available_for_sale:true',
                country: this.dataset.country, language: this.dataset.language } })
          });
          if (!response.ok) throw new Error('Catalog request failed');
          const payload = await response.json();
          const products = payload.data?.products;
          if (payload.errors?.length || !products) throw new Error('Invalid catalog response');
          // Available products load first; sold-out products load last.
          if (products.nodes.some(product => product.availableForSale !== (this.phase !== 'soldout'))) throw new Error('Unexpected availability');
          if (products.pageInfo.hasNextPage && (!products.pageInfo.endCursor || products.pageInfo.endCursor === this.cursor)) throw new Error('Invalid cursor');
          const fresh = products.nodes.filter(product => !this.ids.has(product.id));
          const cards = fresh.map(product => this.card(product));
          const keyboardLoad = document.activeElement === this.next;
          if (!this.started) { this.grid.replaceChildren(); this.started = true; }
          this.grid.append(...cards);
          fresh.forEach(product => this.ids.add(product.id));
          this.grid.style.visibility = '';
          this.grid.dataset.loaded = this.ids.size;
          if (keyboardLoad && cards.length) cards[0].querySelector('a')?.focus({ preventScroll: true });
          if (products.pageInfo.hasNextPage) this.cursor = products.pageInfo.endCursor;
          else if (this.phase === 'nuevo') { this.phase = 'available'; this.cursor = null; } else if (this.phase === 'available') { this.phase = 'soldout'; this.cursor = null; }
          else this.finished = true;
          this.status.textContent = this.finished ? this.dataset.complete : '';
          if (this.finished) { this.next.hidden = true; this.observer?.disconnect(); }
          this.next.removeAttribute('aria-disabled');
        } catch (error) {
          if (this.isConnected && this.controller === controller) {
            this.failed = true;
            this.status.textContent = this.dataset.error;
            this.next.removeAttribute('aria-disabled');
          }
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) {
            this.loading = false;
            this.grid.setAttribute('aria-busy', 'false');
            if (!this.failed && this.isConnected) this.watch();
          }
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
